module.exports = __webpack_public_path__ + "static/img/Pipa 40cm polos.464059d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Pipa 40cm polos.jpg
// module id = 92
// module chunks = 1